import { Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { BomDataHelper } from '../../services/helpers/bom-data-helper';
import { CustomerService } from '../../services/customer.service';
import { FileHelper } from '../../services/helpers/file-helper';
import { environment } from '../../../environments/environment';
import { CurrentService } from '../../services/current.service';
import { ProcessQuoteService } from '../../services/process-quote.service';
import { PrintService } from '../../services/print.service';
import { TranslateService } from '@ngx-translate/core';
import { DatasService } from '../../services/datas.service';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { ProjectService } from 'src/app/services/project.service';
import { Router } from '@angular/router';
import { KitchenService } from 'src/app/services/configurators-2d/applications/kitchen.service';
import { StatisticService } from 'src/app/services/statistic.service';

@Component({
  selector: 'ng-casto-order-products',
  templateUrl: './order-products.component.html',
})
export class OrderProductsComponent implements OnInit {
  public flattenBom: any;
  public beautifiedBom: any;
  public productList: any;
  public productTotalPrice: number;
  public productTotalDeee: number;
  public productTotalEcomob: number;

  public customerInfos: any;
  public projectName: string;

  public vendorEnvironment: any;
  public projectIsSaved: boolean;
  public printLoading: boolean;

  public warningDialogVisible: boolean;

  readonly CONFIG_CONTEXT = CONFIG_CONTEXT;
  legacyProcessQuoteProcessing: boolean;
  dotComPlusProcessQuoteProcessing: boolean;

  constructor(
    public modalService: ModalService,
    public datas: DatasService,
    public customer: CustomerService,
    public processQuote: ProcessQuoteService,
    public project: ProjectService,
    public current: CurrentService,
    public router: Router,
    private print: PrintService,
    private translate: TranslateService,
    private kitchen: KitchenService,
    private statistic: StatisticService
  ) {
    this.customerInfos = {
      name: customer.isLogged ? customer.fullName : '(non identifié)',
      id: customer.isLogged ? customer.userDatas.id : '-',
    };

    this.vendorEnvironment = environment.vendor;
    this.projectIsSaved = current.HBMProject;

    if (environment.vendor) {
      let _rightNow = new Date();
      let currentYYYYMMDD: number = parseInt(_rightNow.toISOString().slice(0, 10).split('-').join(''));
      let storeSwitchDate: number = parseInt(this.current.vendor.store.switchDate);
    }

    let _handledBom = BomDataHelper.extractCategoryGroupedProductsList(modalService.currentDatas.bom);
    this.productTotalPrice = 0;
    this.productTotalDeee = 0;
    this.productTotalEcomob = 0;

    if (!_handledBom.empty) {
      this.productList = [];
      BomDataHelper.orderedCatList.forEach(cat => {
        if (_handledBom[cat].length > 0) {
          this.productList.push({
            key: cat,
            products: _handledBom[cat].map(p => {
              p.pmm = this.datas.getPmmForEan(p.reference);
              return p;
            }),
            subTotal: _handledBom[cat + 'TotalPrice'],
          });
          this.productTotalPrice += _handledBom[cat + 'TotalPrice'];
          this.productTotalDeee += _handledBom[cat + 'TotalDeee'];
          this.productTotalEcomob += _handledBom[cat + 'TotalEcomob'];
        }
      });
    }

    this.warningDialogVisible = false;
  }

  updatePrices() {
    this.productTotalPrice = 0;
    this.productTotalDeee = 0;
    this.productTotalEcomob = 0;

    this.productList.map(cat => {
      cat.subTotal = 0;

      cat.products.map(p => {
        p.totalPrice = p.price.current.value * p.quantity;
        p.totalDeee = p.deee * p.quantity;
        p.totalEcomob = p.ecomob * p.quantity;

        cat.subTotal += p.totalPrice;

        this.productTotalPrice += p.totalPrice;
        this.productTotalDeee += p.totalDeee;
        this.productTotalEcomob += p.totalEcomob;
      });
    });
  }

  showWarningPlinthDialog() {
    this.warningDialogVisible = true;
  }

  handleFlatProductList(): void {
    this.flattenBom = { products: [] };
    this.productList.map(cat => {
      cat.products.map(p => {
        this.flattenBom.products.push(p);
      });
    });
  }

  ngOnInit(): void {
    this.showWarningPlinthDialog();
  }

  close() {
    this.modalService.close();
  }

  back() {
    let _modalId: number = MODAL.PRODUCTS_LIST;
    this.modalService.display(_modalId, {
      bom: this.modalService.currentDatas.bom,
    });
  }

  order() {
    this.sendDotComPlusXml();
  }

  downloadLegacyCommerceCsv(): void {
    let _csvStr: string = this.processQuote.generateLegacyCommerceCSV(
      this.flattenBom.products,
      this.current.HBMProject.uuid,
      this.current.HBMProject.name,
      this.customer.context,
      this.customer.userDatas.id,
      this.customer.fullName,
      this.current.vendor.sapId,
      this.current.vendor.store.legacyStoreId
    );
    let _rightNow = new Date();
    let _fileName: string =
      this.customer.userDatas.lastname.toUpperCase() +
      '_' +
      _rightNow.toISOString().slice(0, 19).replace(/\:/g, '-').replace('T', '_') +
      '_' +
      this.current.HBMProject.name +
      '.csv';

    FileHelper.download(_csvStr, _fileName, 'text/csv;charset=utf-8;');
  }

  downloadDotComPlusXml(): void {
    this.handleFlatProductList();
    let _xmlStr: string = this.processQuote.generateDotComPlusXML(
      this.flattenBom.products,
      this.current.HBMProject.name,
      this.customer.context,
      this.customer.userDatas.id,
      this.current.vendor.sapId,
      this.current.vendor.store.SAPStoreId
    );
    FileHelper.download(_xmlStr, 'Test_DotComPlus_HBM.xml', 'text/xml;charset=utf-8;');
  }

  async sendDotComPlusXml(): Promise<void> {
    this.handleFlatProductList();
    this.dotComPlusProcessQuoteProcessing = true;
    let _dotComPlusProcessQuoteXml: string = this.processQuote.generateDotComPlusXML(
      this.flattenBom.products,
      this.current.HBMProject.name,
      this.customer.context,
      this.customer.userDatas.id,
      this.current.vendor.sapId,
      this.current.vendor.store.SAPStoreId
    );

    this.processQuote.sendDotComPlusOrder(_dotComPlusProcessQuoteXml).then(
      (opportunityRef: number) => {
        this.dotComPlusProcessQuoteProcessing = false;
        // On lock
        this.project.lock(this.current.HBMProject.uuid).then(
          () => {
            //
          },
          (error: any) => {
            //
          }
        );

        this.modalService.display(MODAL.MESSAGE, {
          titleRef: 'popins.opportunityCreated.title',
          contentRef: 'popins.opportunityCreated.text',
          primary: true,
          contentArgs: {
            opportunityNumber: opportunityRef,
          },
          buttons: [
            {
              labelRef: 'popins.opportunityCreated.confirm',
              action: () => {
                this.modalService.close();
              },
            },
          ],
        });
      },
      (error: any) => {
        this.dotComPlusProcessQuoteProcessing = false;
        alert(JSON.stringify(error));
      }
    );
  }

  printList() {
    this.printLoading = true;

    this.print.reset();
    this.print
      .addHeader(this.translate.instant('popins.installation.print_title_' + this.customer.context))
      .then(() => {
        if (this.customer.isLogged) {
          this.print.addText(
            this.translate.instant('popins.products_list.customer_id') + ' ' + this.customerInfos.id,
            'my-3'
          );
          this.print.addText(
            this.translate.instant('popins.products_list.name') + ' ' + this.customerInfos.name,
            'my-3'
          );
        }

        this.print.addText(
          this.translate.instant('popins.products_list.project') +
            ' ' +
            (this.current.HBMProject
              ? this.current.HBMProject.name
              : this.translate.instant('popins.price_info.placeholder_project_' + this.customer.context)),
          'my-3'
        );

        let _rightNow = new Date();
        let _dateStr = _rightNow.toISOString().slice(0, 10).split('-');
        this.print.addText('Le ' + _dateStr[2] + '/' + _dateStr[1] + '/' + _dateStr[0], 'mt-3 mb-5');

        this.print.addDiv(document.querySelector('.price-table-container').cloneNode(true) as HTMLDivElement);

        this.print
          .addTable(document.querySelector('.table.product-table').cloneNode(true) as HTMLTableElement)
          .then(() => {
            let _legacy: string[] = this.translate.instant('popins.products_list.aside.disclaimer').split('<br/>');
            this.print.addText('', 'mt-5');
            _legacy.map(p => {
              this.print.addText(p, 'my-3');
            });

            this.print.print();
            this.printLoading = false;
          });
      });
  }
}
